/**
 * NUYA Animation System
 * Scroll-reveal, hero entrance, stagger, and button ripple effects.
 * Respects prefers-reduced-motion.
 */
(function nuyaAnimations() {
  'use strict';

  // Signal JS availability so CSS can apply initial invisible states
  document.documentElement.classList.add('nuya-js');

  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ANIM_SELECTORS = [
    '.nuya-why__card',
    '.nuya-cat-card',
    '.nuya-color-card',
    '.nuya-review-card',
    '.nuya-community__item',
    '.nuya-usp-bar__item',
    '.nuya-starter__content',
    '.nuya-starter__media',
    '.nuya-story__content',
    '.nuya-story__image',
    '.nuya-story__image-placeholder',
    '.nuya-bestseller__content',
    '.nuya-bestseller__media',
    '.nuya-lifestyle-grid__block--story',
    '.nuya-lifestyle-grid__block--photo',
    '.nuya-lifestyle-grid__block--instagram',
    '.nuya-proof-bar__item',
    '.nuya-cg__card',
    '.nuya-newsletter__inner',
    '.nuya-nl2__inner',
    '.nuya-section-header',
    '.nuya-color-picker__header'
  ];

  const STAGGER_GRIDS = [
    '.nuya-why__grid',
    '.nuya-collections-row',
    '.nuya-color-picker__grid',
    '.nuya-reviews__grid',
    '.nuya-community__strip',
    '.nuya-usp-bar__inner',
    '.nuya-proof-bar__inner',
    '.nuya-lifestyle-grid__inner',
    '.nuya-cg__grid'
  ];

  function makeVisible(el) {
    el.classList.add('nuya-is-visible');
  }

  if (REDUCED_MOTION) {
    function revealAll() {
      document.querySelectorAll(ANIM_SELECTORS.join(',')).forEach(makeVisible);
      const hero = document.querySelector('.nuya-hero__content');
      const heroImg = document.querySelector('.nuya-hero__image-wrap');
      if (hero) makeVisible(hero);
      if (heroImg) makeVisible(heroImg);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealAll);
    } else {
      revealAll();
    }
    return;
  }

  // Intersection Observer for scroll-reveal
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('nuya-is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -48px 0px'
  });

  function applyStaggerDelays() {
    STAGGER_GRIDS.forEach(function (gridSel) {
      document.querySelectorAll(gridSel).forEach(function (grid) {
        Array.from(grid.children).forEach(function (child, i) {
          child.style.transitionDelay = (i * 80) + 'ms';
        });
      });
    });
  }

  function initScrollAnimations() {
    document.querySelectorAll(ANIM_SELECTORS.join(',')).forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHeroEntrance() {
    var heroContent = document.querySelector('.nuya-hero__content');
    var heroImage  = document.querySelector('.nuya-hero__image-wrap');
    // Hero animates on page load, not on scroll
    if (heroContent) setTimeout(function () { makeVisible(heroContent); }, 100);
    if (heroImage)  setTimeout(function () { makeVisible(heroImage); },  300);
  }

  // Button ripple
  function initRipple() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nuya-btn');
      if (!btn) return;

      var ripple = document.createElement('span');
      var rect   = btn.getBoundingClientRect();
      var size   = Math.max(rect.width, rect.height) * 2;

      ripple.setAttribute('aria-hidden', 'true');
      ripple.style.cssText = [
        'position:absolute',
        'width:'  + size + 'px',
        'height:' + size + 'px',
        'left:'   + (e.clientX - rect.left - size / 2) + 'px',
        'top:'    + (e.clientY - rect.top  - size / 2) + 'px',
        'background:rgba(255,255,255,0.28)',
        'border-radius:50%',
        'transform:scale(0)',
        'animation:nuya-ripple 0.55s cubic-bezier(0.22,1,0.36,1) forwards',
        'pointer-events:none'
      ].join(';');

      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(ripple);
      setTimeout(function () { if (ripple.parentNode) ripple.remove(); }, 600);
    });
  }

  // Image lazy-load smooth reveal
  function initImageReveal() {
    document.querySelectorAll('.nuya-hero__image-wrap img, .nuya-starter__image-main img, .nuya-story__image img, .nuya-collection-card__image img').forEach(function (img) {
      img.style.transition = 'opacity 0.5s ease';
      if (!img.complete) {
        img.style.opacity = '0';
        img.addEventListener('load', function () {
          img.style.opacity = '1';
        });
      }
    });
  }

  function init() {
    applyStaggerDelays();
    initScrollAnimations();
    initHeroEntrance();
    initRipple();
    initImageReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
